module.exports = __webpack_public_path__ + "static/media/wc_info_slider_3.a63f123c.svg";